import { render, staticRenderFns } from "./vsBreadcrumb.vue?vue&type=template&id=9df75d44&lang=html"
import script from "./vsBreadcrumb.vue?vue&type=script&lang=js"
export * from "./vsBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports